/* eslint-disable no-unused-vars */
import {
  get as getAxios,
  post as postAxios,
  put as putAxios,
} from "../apiHandler";

const endPoint = process.env.REACT_APP_API_BASE_URL;

const get = (url, { data, accessToken }) =>
  getAxios(url, { data, accessToken, endPoint });
const post = (url, { accessToken, data, params }) =>
  postAxios(url, { accessToken, data, endPoint, params });
const put = (url, { accessToken, data, params }) =>
  putAxios(url, { accessToken, data, endPoint, params });

export default class Auth {
  static login(data) {
    const request = post("/login", {
      data,
    });

    Auth.login.cancel = request.cancel;
    return request;
  }

  static resetPassword({ data }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = post("/resetPassword", {
      data,
      accessToken: accessTokenFromLocal,
    });

    Auth.resetPassword.cancel = request.cancel;
    return request;
  }

  static changePassword({ data }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = post("/updatePasswordByOtp", {
      accessToken: accessTokenFromLocal,
      data,
    });

    Auth.changePassword.cancel = request.cancel;
    return request;
  }
}
